import React from 'react'
import Pt from 'prop-types'
import Ipt from 'react-immutable-proptypes'

import {
  BandwidthPackRecord,
  OfferRecord,
  ProductRecord,
} from 'internal-components/src/records'
import { format as formatBandwidth } from 'internal-components/src/util/Bandwidth'
import {connect} from "react-redux";
import {makeSelectBandwidthPacks} from "../../../deps/internal-components/src/redux/modules/product/selectors";

function describeBandwidthDirection(dir) {
  if (dir === 'both') {
    return 'Combined Usage'
  }

  return dir === 'down' ? 'Downloads' : 'Uploads'
}

function Features({ bandwidthPacks, offer, product }) {
  const features = offer.features.union(product.features)

  return (
    <div className="features">
      <ul>
        {offer.speed && <li className="feature-speed">{offer.speed.replace(/_\d+$/, '')}</li>}
        {bandwidthPacks.map(pack => (
          <li key={`pack-${pack.id}`}>
            {formatBandwidth(pack.bytes)}{' '}
            {describeBandwidthDirection(pack.direction)}
          </li>
        ))}
        {features.map(feature => (
          <li key={`feature-${feature})`} className="feature">
            {feature}
          </li>
        ))}
      </ul>
    </div>
  )
}

Features.propTypes = {
  bandwidthPacks: Ipt.setOf(Pt.instanceOf(BandwidthPackRecord)).isRequired,
  offer: Pt.instanceOf(OfferRecord).isRequired,
  product: Pt.instanceOf(ProductRecord).isRequired,
}

export const makeMapStateToProps = () => {
  const selectBandwidthPacks = makeSelectBandwidthPacks()

  return (state, ownProps) => ({
    bandwidthPacks: selectBandwidthPacks(state, {
      bandwidthPackIds: ownProps.offer.bandwidthPacks,
    }),
  })
}

export default connect(makeMapStateToProps)(Features)



// WEBPACK FOOTER //
// ./src/components/OfferSelector/Features.jsx